
/*fx.ns("shared.screens", class PrintSizeChoices extends shared.screens.BaseChoiceScreen 
{
    constructor()
    {
        super();
        
        this.showNext = false;
        this.showBack = fx.get("mode") == "creating";

        this.styleChoice = "square";

        this.containerHeight = 450;
        this.valign = "top";
        this.title = fx.text("Choisissez la format pour vos tirages");
    }

    create()
    {
        this.choices.push({ data : models.ProductPrint.SQUARE, asset : fx.assets.print_square , name : fx.text("Carré") + "<br><span class='size'>10 x 10cm</span>"});
        this.choices.push({ data : models.ProductPrint.LANDSCAPE, asset : fx.assets.print_rectangle, name : fx.text("Classique") + "<br><span class='size'>15 x 10cm</span>"});
        
        super.create();
    }

    // override
    addTitle(text)
    {
        this.container.addChild( new fx.components.Text( {text : text , className : "title" } ), {width:"90%", height : fx.browser.isDesktop ? 80 : 30, left:"center"});
    }

    // override
    addChoice(choice, viewport)
    {
        if (fx.browser.isDesktop)
            this.hContainer.addChild( choice, viewport || {width: 300 } );
        else
            this.container.addChild( choice, viewport || {width: 300,  left : "center"} );
    }

    onChoiceClicked(obj)
    {      
        this.data.choosedShape = obj;
        this.data.event("next-step");
    }

});*/